import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { ChakraProvider, createSystem, defaultConfig } from "@chakra-ui/react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const system = createSystem(defaultConfig);
root.render(
  <React.StrictMode>
    <ChakraProvider value={system}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
